/**
 * サイドメニューの項目
 * name: API の featureGroup.name と一致させるキー（変更不可）
 * displayName: メニューに表示する名称
 * visibleSlugs: 表示するfeatureのslug（未指定の場合は全て表示）
 */

type NavMenu = {
  name: string;
  displayName: string;
  visibleSlugs?: string[];
  features: {
    slug: string;
    path?: string;
    target?: string;
    displayName?: string;
  }[];
};

const featureDisplayNames: Record<string, string> = {
  "operation-web-school-list": "Nursery Settings",
};

export { featureDisplayNames };

export const navMenuItems: NavMenu[] = [
  {
    name: "Facility Settings",
    displayName: "Nursery Settings",
    features: [{ slug: "operation-web-school-list", path: "/school" }],
  },
  {
    name: "Admin Account",
    displayName: "Admin Account",
    visibleSlugs: [
      "operation-web-management-company",
      "operation-web-management-user",
    ],
    features: [
      { slug: "operation-web-management-company", path: "/admin-account" },
      { slug: "operation-web-management-user", path: "/admin-user" },
    ],
  },
];
